import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import AllProjects from "./Pages/Home/AllProjects.jsx";
import Experience from "./Pages/Home/Expereince.jsx";
import Expertise from "./Pages/Home/Expertise.jsx";
import Home from "./Pages/Home/Homescreen";
import MyJourney from "./Pages/Home/MyJourney.jsx";
import MyQualification from "./Pages/Home/MyQualification.jsx";
import Navbar from "./Pages/Home/Navbar";
function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="*" element={<div>404 Not Found</div>}></Route>

            <Route path="/experience" element={<Experience />} />
            <Route path="/expertise" element={<Expertise />} />
            <Route path="/all-projects" element={<AllProjects />} />
            <Route path="/my-journey" element={<MyJourney />} />
            <Route path="/qualification" element={<MyQualification />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
